import { render } from "./OnboardingHint.vue?vue&type=template&id=f3cdbe74&scoped=true"
import script from "./OnboardingHint.vue?vue&type=script&lang=js"
export * from "./OnboardingHint.vue?vue&type=script&lang=js"

import "./OnboardingHint.vue?vue&type=style&index=0&id=f3cdbe74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3cdbe74"]])

export default __exports__